import { entryMeasure, type Exercise } from "../core/exercises";
import type { NewRecord } from "../core/progress";
import { volume, type Session } from "../core/sessions";
import { useBack } from "./back";
import { Badges } from "./ExercisePage";
import { variantName } from "./HistoryTab";
import { formatClock, formatDate, formatKg, t } from "./texts";

/** After "Beenden": duration, volume, sets per exercise and the new records (PR badges). */
export function WorkoutSummary(props: { session: Session; exercises: Exercise[]; records: NewRecord[]; templateUpdated: boolean; onClose(): void }) {
  useBack(props.onClose);
  const s = props.session;
  const byId = new Map(props.exercises.map((e) => [e.id, e]));
  // exercise and variant (todo 16): records are per variant
  const measureOf = (x: Session["exercises"][number]) => { const g = byId.get(x.exerciseId); return g && entryMeasure(g, x); };
  const sets = s.exercises.reduce((n, x) => n + x.sets.length, 0);
  const kg = volume(s.exercises);
  return (
    <>
      <h1>{t.summary.title}</h1>
      <p className="name">{s.name}</p>
      <dl className="facts">
        <dt>{t.summary.date}</dt><dd>{formatDate(s.endedAt)}</dd>
        <dt>{t.summary.duration}</dt><dd>{formatClock(s.endedAt - s.startedAt)}</dd>
        {kg > 0 && <><dt>{t.summary.volume}</dt><dd>{formatKg(kg)}</dd></>}
        <dt>{t.summary.sets}</dt><dd>{sets}</dd>
      </dl>
      {props.records.length > 0 && <p className="pr-head">🏆 {t.progress.newRecords(props.records.length)}</p>}
      <ul className="list summary-list">
        {s.exercises.map((x, i) => (
          <li key={i} className="list-item static">
            <span className="name">{variantName(byId.get(x.exerciseId)?.name, measureOf(x) !== byId.get(x.exerciseId)?.measure ? measureOf(x) : undefined)}</span>
            <span className="sub">{t.summary.setCount(x.sets.length)}</span>
            {/* an exercise done twice (in the same variant) shows its records once */}
            {s.exercises.findIndex((y) => y.exerciseId === x.exerciseId && measureOf(y) === measureOf(x)) === i &&
              <Badges records={props.records.filter((r) => r.exerciseId === x.exerciseId && r.measure === measureOf(x))} />}
          </li>
        ))}
      </ul>
      {props.templateUpdated && <p className="notice">{t.summary.templateUpdated}</p>}
      <button className="primary wide" onClick={props.onClose}>{t.summary.close}</button>
    </>
  );
}
